/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TenantOrgCapabilitiesRansomwareRecovery { 
    /**
     * Whether Carbon Black on-premises org and API key management is allowed for this organization.
     */
    carbon_black_org_and_api_key_mgmt_allowed?: boolean;
}

